import { MiniStreamingIcon } from '@/components/icons/svg-icons';
import { matchStyles } from '@/features/odds-table-mars/components/match/match.style';
import { setKafkaNormal, setKafkaStreaming } from '@/hooks/query/use-kafka-log';
import { miniStreamingService } from '@/services/mini-streaming.service';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import { getKafkaStreamerType } from '@/utils/common-util';
import { SportMatchModel } from '@nf/types/odds';
import { Button } from '@nf/ui';
import { KafkaNote, StreamingKafkaNote } from '@nf/utils-common/constants';
import { useObservableState } from '@nf/utils-common/hooks';
import { useEffect, useState } from 'react';
import { useAnalyseAttribute } from '@/features/next-analyse';

interface MiniStreamingButtonProps {
    match: SportMatchModel;
}

const notPlayingStreamingMatchId = -1;

export const MiniStreamingButton = ({ match }: MiniStreamingButtonProps) => {
	const { MatchId } = match;
	const onPlayingStreamingMatchId = useObservableState(miniStreamingService.onPlayingStreamingChange$, notPlayingStreamingMatchId);
	const [isShowMiniStreaming, setIsShowMiniStreaming] = useState<boolean>(false);
	const view = useAppearanceStore(state => state.view);
	const analyseAttributeRef = useAnalyseAttribute('use-mini-streaming-button');

	useEffect(() => {
		setIsShowMiniStreaming(MatchId === onPlayingStreamingMatchId);
	}, [MatchId, onPlayingStreamingMatchId]);
    
	const toggleMiniStreaming = (e: React.MouseEvent<HTMLElement>) => {
		e.stopPropagation();
		const willShowMiniStreaming = !isShowMiniStreaming;
		if (view === ViewEnum.mars) {
			const kafkaData = {
				note: KafkaNote.MarsV1,
				type: 6,
				action: 5
			}
			const streamerKafkaData = {
				note: StreamingKafkaNote.MiniStreaming,
				type: 2,
				action: !isShowMiniStreaming ? 1 : 2,
				matchId: 0,
				streamer_type: getKafkaStreamerType(0)
			};
			setKafkaStreaming(streamerKafkaData);	
			setKafkaNormal(kafkaData);
		}
		if (willShowMiniStreaming) {
			miniStreamingService.setPlayingStreamingMatchId(MatchId);
		} else {
			miniStreamingService.setPlayingStreamingMatchId(notPlayingStreamingMatchId);
		}
		setIsShowMiniStreaming(willShowMiniStreaming);
	}

	return (
		<Button
			ref={analyseAttributeRef}
			shape="capsule"
			variant="primaryOutline"
			className={matchStyles.miniStreamingButton}
			onClick={toggleMiniStreaming}
			data-open={isShowMiniStreaming}
		>
			<MiniStreamingIcon />
		</Button>
	);
}